import { Box, Typography } from "@mui/material"
import { SaveOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { Button } from "@/components/common/Button"

interface AccountingSettingsHeaderActionsProps {
  isDirty: boolean
  canSubmit: boolean
  isSubmitting: boolean
  onSaveClick: () => void
}

export const AccountingSettingsHeaderActions: FC<AccountingSettingsHeaderActionsProps> = ({
  isDirty,
  canSubmit,
  isSubmitting,
  onSaveClick,
}) => {
  return (
    <Box className='flex items-center justify-end gap-4'>
      {isDirty && (
        <Typography
          variant='body2'
          className='text-gray-700'
          data-testid='accounting-settings.header-actions.unsaved-changes-text'
        >
          You have unsaved changes.
        </Typography>
      )}
      <Button
        startIcon={<SaveOutlined />}
        disabled={!canSubmit}
        loading={isSubmitting}
        onClick={onSaveClick}
        data-testid='accounting-settings.header-actions.save-button'
      >
        Save Changes
      </Button>
    </Box>
  )
}
